(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["paste-finder"] && !Shopify.designMode) return;
  try {
    

(function () {

  const ORDER = [
    'soft',
    'softplus',
    'pro',
    'proplus',
    'medium',
    'hard'
  ];


  const POINTS = {

    room: {

      cool: {
        soft: 2,
        softplus: 1
      },

      moderate: {
        pro: 2,
        softplus: 1
      },

      warm: {
        proplus: 2,
        pro: 1,
        medium: 1
      },

      hot: {
        medium: 2,
        hard: 2
      }

    },


    humidity: {

      low: {
        soft: 1,
        pro: 1
      },

      seasonal: {
        pro: 1,
        proplus: 1
      },

      high: {
        medium: 2,
        hard: 1
      }

    },


    experience: {

      under1: {
        medium: 3
      },

      '1to3': {
        pro: 2,
        proplus: 1
      },

      '3plus': {
        soft: 1,
        softplus: 1,
        pro: 1
      }

    },


    pace: {

      fast: {
        soft: 1,
        pro: 1
      },

      moderate: {},

      slow: {
        proplus: 1,
        medium: 1,
        hard: 1
      }

    },


    services: {

      brazilian: {
        proplus: 1,
        medium: 1,
        pro: 1
      },

      large: {
        soft: 2,
        softplus: 2,
        pro: 2
      },

      underarm: {
        proplus: 2,
        medium: 1,
        pro: 1
      },

      facial: {
        softplus: 2,
        pro: 1
      },

      mixed: {
        pro: 2
      }

    },


    challenge: {

      sticky: {
        proplus: 2,
        medium: 2,
        hard: 1
      },

      firm: {
        soft: 2,
        softplus: 1,
        pro: 1
      },

      inconsistent: {
        pro: 2,
        proplus: 1
      },

      none: {
        pro: 1
      }

    },


    hands: {

      warm: {
        proplus: 2,
        medium: 1,
        hard: 1
      },

      neutral: {
        pro: 1
      },

      cool: {
        soft: 2,
        softplus: 1
      }

    },


    mixing: {

      yes: {
        hard: 1
      },

      maybe: {},

      single: {
        pro: 1,
        medium: 1
      }

    }

  };



  function stpqIdentify(properties) {

    try {

      window.klaviyo =
        window.klaviyo || [];


      if (
        typeof window.klaviyo.identify ===
        'function'
      ) {

        return window.klaviyo.identify(
          properties
        );

      }


      if (
        typeof window.klaviyo.push ===
        'function'
      ) {

        window.klaviyo.push([
          'identify',
          properties
        ]);

      }

    }

    catch (error) {

      console.warn(
        'Paste Finder identify error',
        error
      );

    }

  }



  function stpqTrack(
    eventName,
    properties
  ) {

    try {

      window.klaviyo =
        window.klaviyo || [];


      if (
        typeof window.klaviyo.track ===
        'function'
      ) {

        return window.klaviyo.track(
          eventName,
          properties || {}
        );

      }


      if (
        typeof window.klaviyo.push ===
        'function'
      ) {

        window.klaviyo.push([
          'track',
          eventName,
          properties || {}
        ]);

      }

    }

    catch (error) {

      console.warn(
        'Paste Finder track error',
        error
      );

    }

  }



  function initializePasteFinder(root) {

    if (
      !root ||
      root.dataset.stpqInitialized ===
      'true'
    ) {
      return;
    }


    root.dataset.stpqInitialized =
      'true';



    const canWholesalePurchase =
      root.dataset.canWholesalePurchase ===
      'true';


    const professionalApplicationUrl =
      root.dataset.professionalApplicationUrl ||
      '/pages/professional-account-application';


    const loginUrl =
      root.dataset.loginUrl ||
      '/account/login';


    const cover =
      root.querySelector(
        '[data-cover]'
      );


    const main =
      root.querySelector(
        '[data-main]'
      );


    const quiz =
      root.querySelector(
        '[data-quiz]'
      );


    const lead =
      root.querySelector(
        '[data-lead]'
      );


    const results =
      root.querySelector(
        '[data-results]'
      );


    const form =
      root.querySelector(
        '[data-form]'
      );


    const leadForm =
      root.querySelector(
        '[data-lead-form]'
      );


    const nextButton =
      root.querySelector(
        '[data-next]'
      );


    const backButton =
      root.querySelector(
        '[data-back]'
      );


    const error =
      root.querySelector(
        '[data-error]'
      );


    const leadError =
      root.querySelector(
        '[data-lead-error]'
      );


    const steps =
      Array.from(
        root.querySelectorAll(
          '[data-step]'
        )
      );


    const products =
      {};


    root
      .querySelectorAll(
        '[data-products] [data-key]'
      )
      .forEach(function (element) {

        products[
          element.dataset.key
        ] = {
          ...element.dataset
        };

      });



    let currentStep =
      0;


    let finalAnswers =
      null;


    let finalRanking =
      null;



    function selected(name) {

      return form.querySelector(
        'input[name="' +
        name +
        '"]:checked'
      );

    }



    function selectedLabel(name) {

      const input =
        selected(name);


      return input
        ? input.dataset.label || ''
        : '';

    }



    function answerValues() {

      const answers =
        {};


      Object
        .keys(POINTS)
        .forEach(function (name) {

          const input =
            selected(name);


          answers[name] =
            input
              ? input.value
              : null;

        });


      return answers;

    }



    function answerLabels() {

      return {

        room:
          selectedLabel('room'),

        humidity:
          selectedLabel('humidity'),

        experience:
          selectedLabel('experience'),

        pace:
          selectedLabel('pace'),

        services:
          selectedLabel('services'),

        challenge:
          selectedLabel('challenge'),

        hands:
          selectedLabel('hands'),

        mixing:
          selectedLabel('mixing')

      };

    }



    function showStep(index) {

      currentStep =
        index;


      steps.forEach(
        function (step, i) {

          step.hidden =
            i !== index;

        }
      );


      const number =
        index + 1;


      const percent =
        Math.round(
          number /
          steps.length *
          100
        );


      root
        .querySelector(
          '[data-progress-label]'
        )
        .textContent =
          'Question ' +
          number +
          ' of ' +
          steps.length;


      root
        .querySelector(
          '[data-progress-percent]'
        )
        .textContent =
          percent + '%';


      root
        .querySelector(
          '[data-progress-bar]'
        )
        .style.width =
          percent + '%';


      root
        .querySelector(
          '[role="progressbar"]'
        )
        .setAttribute(
          'aria-valuenow',
          number
        );


      backButton.hidden =
        index === 0;


      nextButton.textContent =
        index === steps.length - 1
          ? 'Find My Match'
          : 'Next';


      error.hidden =
        true;

    }



    function rankAnswers(data) {

      const scores =
        {};


      ORDER.forEach(
        function (key) {

          scores[key] = 0;

        }
      );


      Object
        .entries(data)
        .forEach(
          function (entry) {

            const question =
              entry[0];


            const answer =
              entry[1];


            const awards =
              (
                POINTS[question] &&
                POINTS[question][answer]
              )
              || {};


            Object
              .entries(awards)
              .forEach(
                function (award) {

                  scores[
                    award[0]
                  ] +=
                    award[1];

                }
              );

          }
        );



      /* EDUCATOR BOOST */

      if (
        data.services ===
        'brazilian'
      ) {

        if (
          data.room === 'hot' ||
          data.humidity === 'high'
        ) {

          scores.hard += 2;

          scores.medium += 2;

          scores.proplus += 2;

        }

        else if (
          data.room === 'cool'
        ) {

          scores.medium += 2;

          scores.pro += 2;

          scores.proplus += 2;

        }

      }



      return ORDER

        .map(
          function (
            key,
            softness
          ) {

            return {
              key: key,
              score: scores[key],
              softness: softness
            };

          }
        )

        .sort(
          function (a,b) {

            return (
              b.score -
              a.score ||
              a.softness -
              b.softness
            );

          }
        );

    }



    function resultExplanation(
      data,
      title
    ) {

      const reasons =
        [];


      if (
        data.room === 'hot' ||
        data.humidity === 'high'
      ) {

        reasons.push(
          'your warmer or more humid working environment'
        );

      }

      else if (
        data.room === 'cool'
      ) {

        reasons.push(
          'your cooler treatment room'
        );

      }


      if (
        data.hands === 'warm'
      ) {

        reasons.push(
          'your warm hands'
        );

      }

      else if (
        data.hands === 'cool'
      ) {

        reasons.push(
          'your cool hands'
        );

      }


      if (
        data.experience ===
        'under1'
      ) {

        reasons.push(
          'your current experience level'
        );

      }


      if (
        data.challenge ===
        'sticky'
      ) {

        reasons.push(
          'your need for more stability when paste gets soft or sticky'
        );

      }

      else if (
        data.challenge ===
        'firm'
      ) {

        reasons.push(
          'your preference for a paste that glides more easily'
        );

      }


      if (
        data.services ===
        'brazilian'
      ) {

        reasons.push(
          'your focus on Brazilian and bikini services'
        );

      }


      const selectedReasons =
        reasons.slice(0,3);


      if (
        selectedReasons.length
      ) {

        let joined =
          selectedReasons.join(', ');


        joined =
          joined.replace(
            /, ([^,]*)$/,
            ' and $1'
          );


        return (
          title +
          ' matched with ' +
          joined +
          '.'
        );

      }


      return (
        title +
        ' is the closest match for the way you work.'
      );

    }



    function productCard(
      item,
      data,
      secondary
    ) {

      const product =
        products[item.key] || {};


      const exists =
        Boolean(
          product.variantId &&
          product.url
        );


      const available =
        product.available ===
        'true';


      const image =
        product.image

        ? (
          '<div class="stpq__image">' +
            '<img ' +
              'src="' +
              product.image +
              '" ' +
              'alt="' +
              (
                product.productTitle ||
                product.title ||
                ''
              ) +
              '" ' +
              'loading="lazy">' +
          '</div>'
        )

        : (
          '<div class="stpq__image"></div>'
        );



      const why =
        secondary

        ? 'A strong alternate when you want to adjust slightly softer or firmer.'

        : resultExplanation(
            data,
            product.title ||
            item.key
          );



      let actions =
        '';


      if (
        canWholesalePurchase
      ) {

        const addLabel =
          !exists
          ? 'Product unavailable'
          : (
              available
              ? (
                  'Add ' +
                  product.title +
                  ' — ' +
                  product.price
                )
              : 'Sold out'
            );


        actions +=
          '<button ' +
            'type="button" ' +
            'class="stpq__button" ' +
            'data-add="' +
            (
              product.variantId ||
              ''
            ) +
            '" ' +
            'data-recommendation-key="' +
            item.key +
            '" ' +
            (
              (!exists || !available)
                ? 'disabled'
                : ''
            ) +
          '>' +
            addLabel +
          '</button>';


        if (
          product.url
        ) {

          actions +=
            '<a ' +
              'class="stpq__button stpq__button--light" ' +
              'href="' +
              product.url +
              '" ' +
              'data-view-product="' +
              item.key +
              '">' +
              'View Product' +
            '</a>';

        }


        actions +=
          '<p ' +
            'class="stpq__status" ' +
            'data-cart-status ' +
            'aria-live="polite">' +
          '</p>';

      }

      else {

        actions +=
          '<a ' +
            'class="stpq__button" ' +
            'href="' +
            professionalApplicationUrl +
            '">' +
            'Create a Professional Account' +
          '</a>';


        actions +=
          '<a ' +
            'class="stpq__button stpq__button--light" ' +
            'href="' +
            loginUrl +
            '">' +
            'Sign In' +
          '</a>';


        actions +=
          '<div class="stpq__gate">' +
            '<strong>' +
              'Professional Purchasing' +
            '</strong>' +
            'Sign in with an approved wholesale account or apply for a professional account to purchase this paste.' +
          '</div>';

      }



      return (
        '<article class="stpq__product' +
          (
            secondary
            ? ' stpq__product--secondary'
            : ''
          ) +
        '">' +

          image +

          '<div>' +

            '<h3>' +
              (
                product.title ||
                item.key
              ) +
            '</h3>' +

            '<p class="stpq__why">' +
              why +
            '</p>' +

            (
              product.price
              ? (
                  '<p class="stpq__price">' +
                    product.price +
                  '</p>'
                )
              : ''
            ) +

            '<div class="stpq__actions">' +
              actions +
            '</div>' +

          '</div>' +

        '</article>'
      );

    }



    function openLeadCapture() {

      finalAnswers =
        answerValues();


      finalRanking =
        rankAnswers(
          finalAnswers
        );


      quiz.hidden =
        true;


      lead.hidden =
        false;


      leadError.hidden =
        true;


      setTimeout(
        function () {

          const firstField =
            leadForm.querySelector(
              '[name="first_name"]'
            );


          if (
            firstField &&
            !firstField.value
          ) {

            firstField.focus();

          }

          else {

            const emailField =
              leadForm.querySelector(
                '[name="email"]'
              );


            if (emailField) {
              emailField.focus();
            }

          }

        },
        100
      );


      root.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

    }



    function revealResults() {

      root
        .querySelector(
          '[data-primary]'
        )
        .innerHTML =
          productCard(
            finalRanking[0],
            finalAnswers,
            false
          );


      root
        .querySelector(
          '[data-secondary]'
        )
        .innerHTML =
          productCard(
            finalRanking[1],
            finalAnswers,
            true
          );


      lead.hidden =
        true;


      results.hidden =
        false;


      root.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

    }



    /* ======================================================
       START
    ======================================================= */

    root
      .querySelector(
        '[data-start]'
      )
      .addEventListener(
        'click',
        function () {

          cover.hidden =
            true;


          main.hidden =
            false;


          showStep(0);


          stpqTrack(
            'Paste Quiz Started',
            {

              Quiz:
                'Sweet & True Paste Finder',

              Quiz_Version:
                '2',

              Quiz_Page:
                window.location.pathname

            }
          );


          root.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });

        }
      );



    /* ======================================================
       QUESTION NAV
    ======================================================= */

    nextButton.addEventListener(
      'click',
      function () {

        const choice =
          steps[currentStep]
            .querySelector(
              'input:checked'
            );


        if (
          !choice
        ) {

          error.hidden =
            false;

          return;

        }


        if (
          currentStep <
          steps.length - 1
        ) {

          showStep(
            currentStep + 1
          );

        }

        else {

          openLeadCapture();

        }

      }
    );



    backButton.addEventListener(
      'click',
      function () {

        showStep(
          Math.max(
            0,
            currentStep - 1
          )
        );

      }
    );



    steps.forEach(
      function (step) {

        step.addEventListener(
          'change',
          function () {

            error.hidden =
              true;

          }
        );

      }
    );



    /* ======================================================
       LEAD SUBMIT
    ======================================================= */

    leadForm.addEventListener(
      'submit',
      async function (event) {

        event.preventDefault();


        leadError.hidden =
          true;



        const firstName =
          leadForm
            .querySelector(
              '[name="first_name"]'
            )
            .value
            .trim();


        const lastName =
          leadForm
            .querySelector(
              '[name="last_name"]'
            )
            .value
            .trim();


        const email =
          leadForm
            .querySelector(
              '[name="email"]'
            )
            .value
            .trim();


        const marketingIntent =
          leadForm
            .querySelector(
              '[name="marketing_opt_in"]'
            )
            .checked;



        if (
          !firstName ||
          !lastName ||
          !email
        ) {

          leadError.textContent =
            'Please enter your first name, last name and email to reveal your result.';


          leadError.hidden =
            false;


          return;

        }



        const validEmail =
          /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            .test(email);


        if (
          !validEmail
        ) {

          leadError.textContent =
            'Please enter a valid email address.';


          leadError.hidden =
            false;


          return;

        }



        const revealButton =
          root.querySelector(
            '[data-reveal]'
          );


        const originalButton =
          revealButton.innerHTML;


        revealButton.disabled =
          true;


        revealButton.textContent =
          'FINDING YOUR MATCH…';



        const primary =
          finalRanking[0];


        const secondary =
          finalRanking[1];


        const primaryProduct =
          products[primary.key] || {};


        const secondaryProduct =
          products[secondary.key] || {};


        const labels =
          answerLabels();


        const completedAt =
          new Date().toISOString();



        const profileProperties = {

          email:
            email,

          first_name:
            firstName,

          last_name:
            lastName,

          'Paste Quiz Result':
            (
              primaryProduct.title ||
              primary.key
            ),

          'Paste Quiz Result Key':
            primary.key,

          'Paste Quiz Secondary':
            (
              secondaryProduct.title ||
              secondary.key
            ),

          'Paste Quiz Completed':
            true,

          'Paste Quiz Last Completed':
            completedAt,

          'Paste Quiz Marketing Intent':
            marketingIntent

        };



        const eventProperties = {

          Recommended_Paste:
            (
              primaryProduct.title ||
              primary.key
            ),

          Recommended_Paste_Key:
            primary.key,

          Recommended_Paste_URL:
            primaryProduct.url || '',

          Recommended_Paste_Variant_ID:
            primaryProduct.variantId || '',

          Recommended_Paste_Score:
            primary.score,

          Also_Consider:
            (
              secondaryProduct.title ||
              secondary.key
            ),

          Also_Consider_Key:
            secondary.key,

          Also_Consider_URL:
            secondaryProduct.url || '',

          Also_Consider_Score:
            secondary.score,

          Room_Temperature:
            labels.room,

          Humidity:
            labels.humidity,

          Experience:
            labels.experience,

          Service_Pace:
            labels.pace,

          Services:
            labels.services,

          Paste_Challenge:
            labels.challenge,

          Hand_Temperature:
            labels.hands,

          Mixing_Preference:
            labels.mixing,

          Marketing_Opt_In_Intent:
            marketingIntent,

          Quiz:
            'Sweet & True Paste Finder',

          Quiz_Version:
            '2',

          Quiz_Page:
            window.location.pathname,

          Completed_At:
            completedAt

        };



        try {

          const identifyResult =
            stpqIdentify(
              profileProperties
            );


          if (
            identifyResult &&
            typeof identifyResult.then ===
            'function'
          ) {

            await identifyResult;

          }



          const trackingResult =
            stpqTrack(
              'Paste Quiz Completed',
              eventProperties
            );


          if (
            trackingResult &&
            typeof trackingResult.then ===
            'function'
          ) {

            await trackingResult;

          }

        }

        catch (trackingError) {

          console.warn(
            'Paste Finder Klaviyo tracking issue',
            trackingError
          );

        }



        revealButton.innerHTML =
          originalButton;


        revealButton.disabled =
          false;


        revealResults();

      }
    );



    /* ======================================================
       PRODUCT VIEW TRACKING
    ======================================================= */

    results.addEventListener(
      'click',
      function (event) {

        const productLink =
          event.target.closest(
            '[data-view-product]'
          );


        if (
          !productLink
        ) {
          return;
        }


        const key =
          productLink.dataset.viewProduct;


        const product =
          products[key] || {};


        const isPrimary =
          finalRanking &&
          finalRanking[0] &&
          finalRanking[0].key === key;


        stpqTrack(
          'Paste Quiz Recommendation Viewed',
          {

            Product:
              product.title || key,

            Product_Key:
              key,

            Product_URL:
              product.url || '',

            Recommendation_Type:
              (
                isPrimary
                ? 'Primary'
                : 'Secondary'
              ),

            Primary_Recommendation:
              (
                finalRanking
                ? (
                    products[
                      finalRanking[0].key
                    ].title
                  )
                : ''
              )

          }
        );

      }
    );



    /* ======================================================
       ADD TO CART
    ======================================================= */

    results.addEventListener(
      'click',
      async function (event) {

        const button =
          event.target.closest(
            '[data-add]'
          );


        if (
          !button ||
          button.disabled
        ) {
          return;
        }



        const status =
          button
            .parentElement
            .querySelector(
              '[data-cart-status]'
            );


        const original =
          button.textContent;


        const key =
          button.dataset
            .recommendationKey;


        const product =
          products[key] || {};


        const isPrimary =
          finalRanking &&
          finalRanking[0] &&
          finalRanking[0].key === key;


        button.disabled =
          true;


        button.textContent =
          'Adding…';


        if (status) {
          status.textContent = '';
        }



        try {

          const rootPath =
            (
              window.Shopify &&
              window.Shopify.routes &&
              window.Shopify.routes.root
            )
            || '/';


          const response =
            await fetch(
              rootPath +
              'cart/add.js',
              {

                method:
                  'POST',

                headers: {

                  'Content-Type':
                    'application/json',

                  'Accept':
                    'application/json'

                },

                body:
                  JSON.stringify({

                    items: [

                      {

                        id:
                          Number(
                            button.dataset.add
                          ),

                        quantity:
                          1

                      }

                    ]

                  })

              }
            );


          if (
            !response.ok
          ) {

            throw new Error(
              'Could not add this paste.'
            );

          }



          button.textContent =
            'Added to Cart ✓';


          if (status) {

            status.textContent =
              'Your paste is in the cart.';

          }



          stpqTrack(
            'Paste Quiz Recommendation Added to Cart',
            {

              Product:
                product.title || key,

              Product_Key:
                key,

              Product_URL:
                product.url || '',

              Product_Variant_ID:
                product.variantId || '',

              Product_Price:
                product.price || '',

              Recommendation_Type:
                (
                  isPrimary
                  ? 'Primary'
                  : 'Secondary'
                ),

              Primary_Recommendation:
                (
                  finalRanking
                  ? (
                      products[
                        finalRanking[0].key
                      ].title
                    )
                  : ''
                ),

              Also_Consider:
                (
                  finalRanking
                  ? (
                      products[
                        finalRanking[1].key
                      ].title
                    )
                  : ''
                )

            }
          );



          document.dispatchEvent(
            new CustomEvent(
              'cart:refresh',
              {
                bubbles: true
              }
            )
          );


          document.dispatchEvent(
            new CustomEvent(
              'cart:updated',
              {
                bubbles: true
              }
            )
          );

        }

        catch (error) {

          button.disabled =
            false;


          button.textContent =
            original;


          if (status) {

            status.textContent =
              (
                error.message ||
                'Please try again.'
              );

          }

        }

      }
    );



    /* ======================================================
       RETAKE
    ======================================================= */

    root
      .querySelector(
        '[data-retake]'
      )
      .addEventListener(
        'click',
        function () {

          form.reset();

          leadForm.reset();


          finalAnswers =
            null;


          finalRanking =
            null;


          results.hidden =
            true;


          lead.hidden =
            true;


          quiz.hidden =
            false;


          showStep(0);


          stpqTrack(
            'Paste Quiz Retaken',
            {

              Quiz:
                'Sweet & True Paste Finder',

              Quiz_Version:
                '2'

            }
          );


          root.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });

        }
      );



    showStep(0);

  }



  function initializeAllPasteFinders() {

    document
      .querySelectorAll(
        '[data-stpq-root]'
      )
      .forEach(
        initializePasteFinder
      );

  }



  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initializeAllPasteFinders
    );

  }

  else {

    initializeAllPasteFinders();

  }



  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const sectionRoot =
        event.target.querySelector
        ? event.target.querySelector(
            '[data-stpq-root]'
          )
        : null;


      if (sectionRoot) {

        initializePasteFinder(
          sectionRoot
        );

      }

    }
  );

})();


  } catch(e) { console.error(e); }
})();
})();
